import { render, staticRenderFns } from "./AppLinkBtn.vue?vue&type=template&id=f4dc5020&scoped=true&"
import script from "./AppLinkBtn.vue?vue&type=script&lang=js&"
export * from "./AppLinkBtn.vue?vue&type=script&lang=js&"
import style0 from "./AppLinkBtn.vue?vue&type=style&index=0&id=f4dc5020&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4dc5020",
  null
  
)

export default component.exports